export default __webpack_public_path__ + "static/media/ISEO CLASS-10 EXAM PATTERN 2026-27.06632922.pdf";